import Organization from '@/views/organization'
import List from '@/views/organization/list'
export default {
  path: 'organization',
  component: Organization,
  name: 'trash.organization',
  redirect: 'organization/list',
  children: [
    {
      path: 'list',
      name: 'organization.list',
      component: List
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/organizations/organization.js